export const forYouItems: string[] = [
  'You volunteered to coach and you have never played lacrosse',
  'You are a PE teacher adding lacrosse to your program',
  'You coach a club team and you have no time to plan',
  'You want a real season structure, not a folder of random drills',
]

export const notForYouItems: string[] = [
  'You are looking for a video course or an app',
  "You coach men's lacrosse — this covers women's rules only",
  'You want someone else to run your sessions for you',
  'You are not willing to print anything',
]
